import React from 'react';
import SEOHead from './SEOHead';
import useSEO from '../hooks/useSEO';

const PageWrapper = ({ children, customSEO = {} }) => {
  const seoData = useSEO(customSEO);
  
  return (
    <>
      <SEOHead {...seoData} />
      {children}
    </>
  );
};

export default PageWrapper;
